'use client';
import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import GridTable from '../../shared/components/grid/GridTable';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider, {
  useColumnContextAPI,
} from '../../shared/context/GetAllColumnContext';
import { useEffect } from 'react';
import CommitHandler from '../../features/user-identities/CommitHandler';
import { UserIdValidator } from '../../features/user-identities/userIdValidator';

const UserIdentitiesPage = () => {
  const { loading, error, screenTables } = useFetchScreenDetails('user_identities');

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>Data is not available</Banner>}
          {!screenTables
            ? null
            : screenTables.map((item) => (
                <GetAllColumnContextProvider key={item.id}>
                  <UserIdentities tableRes={item} />
                </GetAllColumnContextProvider>
              ))}
        </Layout>
      )}
    </>
  );
};

export default UserIdentitiesPage;

const UserIdentities = ({ tableRes }) => {
  const { allColumns, updateCustomConfig, setAllDropdowns, allDropdowns } = useColumnContextAPI();
  const active = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ];
  useEffect(() => {
    if (allColumns?.length) {
      setAllDropdowns({ ...allDropdowns, active });
    }
  }, [allDropdowns?.pcnr_id]);
  useEffect(() => {
    updateCustomConfig({
      AdditionalSortQuery: `(order_by: {lastname: asc})`,
      CommitHandler,
      uniqueValidator: UserIdValidator,
    });
  }, []);
  return <GridTable tableRes={tableRes} />;
};
